module.exports = __webpack_public_path__ + "img/saga.50636c9e.png";